import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { accountsClient } from '../../../utils/apollo/api'
import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'

const QUERY = gql`
  query Profiles($search: String, $page: Int, $filter: ProfileFilter) {
    profiles(search: $search, page: $page, filter: $filter, sort: { field: NAME, type: ASC }) {
      id
      name
      label
    }
  }
`

export const useProfilesLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: accountsClient })

  return (search, page = 1) => {
    return query({ search, page, filter })?.then(pathOr([], ['data', 'profiles']))
  }
}

const ProfileSelect = ({ onChange, value, baseOnly, ...props }) => {
  const getOptions = useProfilesLoader({ baseOnly })

  return (
    <Select
      value={value} //
      onChange={onChange}
      options={getOptions}
      labelField="label"
      {...props}
    />
  )
}

export default ProfileSelect
